import React from 'react';
import { useSelector } from 'react-redux';
import { EditPolicyTransactionDialog } from '@/components/dialogs/EditLinkedPolicyTransactionDialog';
import { CompleteDealDialog } from '@/components/dialogs/CompleteDealDialog';
import { PoliciesSelectProvider } from '@/context/policiesContext';

/**
 * Policy transaction dialogs shared by the deal and debtor views.
 */
export const DealDialogs = () => {
	const completeDealOpen = useSelector((state) => state.dialog.open?.completeDeal);

	return (
		<>
			<PoliciesSelectProvider>
				<EditPolicyTransactionDialog />
			</PoliciesSelectProvider>
			{completeDealOpen && (
				<PoliciesSelectProvider>
					<CompleteDealDialog />
				</PoliciesSelectProvider>
			)}
		</>
	);
};
